//LIVING ROOM COMPONENTS
import BackgroundLivingRoom from "../assets/background-livingroom-pc.jpg";
import TvLivingRoom from "../assets/tv-livingroom-pc.png";
import LuminaireLivingRoom from "../assets/luminaire-livingroom-pc.png";
import BookcaseLivingRoom from "../assets/bookcase-livingroom-pc.png";
import PlantLivingRoom from "../assets/plant-livingroom-pc.png";

//BEDROOM COMPONENTS
import BackgroundBedroom from "../assets/background-bedroom-pc.jpg";
import TvBedroom from "../assets/tv-bedroom-pc.png";
import Bed from "../assets/bed-pc.png";
import BookcaseBedroom from "../assets/bookcase-bedroom-pc.png";
import PlantBedroom from "../assets/plant-bedroom-pc.png";

//KITCHEN COMPONENTS
import BackgroundKitchen from '../assets/background-kitchen-pc.jpg';
import TvKitchen from '../assets/tv-kitchen-pc.png';
import TableKitchen from '../assets/table-kitchen-pc.png';
import ChairsKitchen from '../assets/chairs-kitchen-pc.png';
import PlantKitchen from '../assets/plant-kitchen-pc.png';
import SinkKitchen from '../assets/sink-kitchen-pc.png';

//TVROOM COMPONENTS
import BackgroundTvRoom from "../assets/background-tvroom-pc.jpg";
import TvTvRoom from "../assets/tv-tvroom-pc.png";
import ReclinerLeft from "../assets/recliner-left-tvroom-pc.png";
import ReclinerRight from "../assets/recliner-right-tvroom-pc.png";

//OUTSIDE ROOM COMPONENTS
import BackgroundOutside from "../assets/background-outside-pc.jpg";
import TvOutside from "../assets/tv-outside-pc.png";
import ChairsOutside from "../assets/chairs-outside-pc.png";

//OFFICE COMPONENTS
import BackgroundOffice from "../assets/background-office-pc.png";
import ChairAndTableOffice from "../assets/chair-and-table-office-pc.png";
import PlantOffice from "../assets/plant-office-pc.png";
import TvOffice from "../assets/tv-office-pc.png";

const rooms = [
  {
    index: 1,
    name: 'Sala de estar',
    analytics: 'btn_sala_estar',
    adobeAnalytics: 'sala-de-estar',
    assets: [
      {
        class: 'background-choose-your-room bg-living-room',
        component: BackgroundLivingRoom,
      },
      {
        class: 'tv-choose-your-room absolute-choose-your-room tv-living-room',
        component: TvLivingRoom,
      },
      {
        class: 'luminaire absolute-choose-your-room transform-choose-your-room',
        component: LuminaireLivingRoom,
        style: `
            z-index: 1;
            bottom: 0;
            right: 55%;
        `,
      },
      {
        class: 'bookcase-livingroom absolute-choose-your-room transform-choose-your-room',
        component: BookcaseLivingRoom,
        style: `
          bottom: 0;
          right: calc(50% - 838px);
        `,
      },
      {
        class: 'plant-livingroom absolute-choose-your-room',
        component: PlantLivingRoom,
        style: `
          bottom: 0;
          left: 43%;
        `,
      },
    ]
  },
  {
    index: 2,
    name: 'Quarto',
    analytics: 'btn_quarto',
    adobeAnalytics: 'quarto',
    assets: [
      {
        class: 'background-choose-your-room bg-bed-room',
        component: BackgroundBedroom,
      },
      {
        class: 'tv-choose-your-room absolute-choose-your-room tv-bedroom',
        component: TvBedroom,
        style: `
          z-index: 0;
        `,
      },
      {
        class: 'bed absolute-choose-your-room',
        component: Bed,
        style: `
          bottom: 0;
          left: calc(50% - 470px);
          z-index: 1;
        `,
      },
      {
        class: 'bookcase-bedroom absolute-choose-your-room',
        component: BookcaseBedroom,
        style: `
          bottom: 0;
          left: calc(50% - 160px);
          z-index: 0;
        `,
      },
      {
        class: 'plant-bedroom absolute-choose-your-room',
        component: PlantBedroom,
        style: `
          bottom: 6%;
          right: 49%;
          z-index: 0;
        `,
      },
    ]
  },
  {
    index: 3,
    name: 'Cozinha',
    analytics: 'btn_cozinha',
    adobeAnalytics: 'cozinha',
    assets: [
      {
        class: 'background-choose-your-room bg-kitchen',
        component: BackgroundKitchen,
      },
      {
        class: 'tv-choose-your-room absolute-choose-your-room tv-kitchen',
        component: TvKitchen,
        style: `
          width: 41%;
        `,
      },
      {
        class: 'table-kitchen absolute-choose-your-room',
        component: TableKitchen,
        style: `
          bottom: 0;
          left: calc(50% - 332px);
          z-index: 2;
        `,
      },
      {
        class: 'chairs-kitchen absolute-choose-your-room',
        component: ChairsKitchen,
        style: `
          bottom: 0;
          right: calc(50% - 590px);
          z-index: 1;
        `,
      },
      {
        class: 'plant-kitchen absolute-choose-your-room',
        component: PlantKitchen,
        style: `
          bottom: 0;
          right: 60%;
          z-index: 0;
        `,
      },
      {
        class: 'sink absolute-choose-your-room',
        component: SinkKitchen,
        style: `
          bottom: 0;
          left: 61%;
          z-index: 0;
        `,
      }
    ]
  },
  {
    index: 4,
    name: 'Sala de TV',
    analytics: 'btn_sala_tv',
    adobeAnalytics: 'sala-de-tv',
    assets: [
      {
        class: 'background-choose-your-room bg-tv-room',
        component: BackgroundTvRoom,
      },
      {
        class: 'tv-choose-your-room absolute-choose-your-room tv-room',
        component: TvTvRoom,
      },
      {
        class: 'recliner-left absolute-choose-your-room',
        component: ReclinerLeft,
        style: `
          bottom: 0;
          right: calc(50% - 70px);
        `,
      },
      {
        class: 'recliner-right absolute-choose-your-room',
        component: ReclinerRight,
        style: `
          bottom: 0;
          left: calc(50% - 220px);
        `,
      },
    ]
  },
  {
    index: 5,
    name: 'Escritório',
    analytics: 'btn_escritorio',
    adobeAnalytics: 'escritorio',
    assets: [
      {
        class: 'background-choose-your-room bg-office',
        component: BackgroundOffice,
      },
      {
        class: 'tv-choose-your-room absolute-choose-your-room tv-office',
        component: TvOffice,
        style: `
          top: 23%;
          width: 36.7%;
        `,
      },
      {
        class: 'plant-office absolute-choose-your-room',
        component: PlantOffice,
        style: `
          bottom: 0;
          left: 0;
          z-index: 0;
        `,
      },
      {
        class: 'chair-and-table-office absolute-choose-your-room',
        component: ChairAndTableOffice,
        style: `
          bottom: 0;
          right: 0;
          z-index: 1;
        `,
      },
    ]
  },
  {
    index: 6,
    name: 'Área externa',
    analytics: 'btn_area_exerna',
    adobeAnalytics: 'area-externa',
    assets: [
      {
        class: 'background-choose-your-room bg-outside',
        component: BackgroundOutside,
      },
      {
        class: 'tv-choose-your-room absolute-choose-your-room tv-outside',
        component: TvOutside,
        style: `
          width: 40.7%;
        `,
      },
      {
        class: 'chairs-outside absolute-choose-your-room largeAssets',
        component: ChairsOutside,
        style: `
          bottom: 0;
          z-index: 0;
        `,
      },
    ]
  },
];

export default rooms;